export const ERROR_MESSAGES = {
  400: {
    title: `400 Bad Request`,
    message: `Uh oh! It looks like there was a problem with your request. Don't worry, just try again and everything should work out.`,
  },
  401: {
    title: `401 Unauthorized`,
    message: `Whoops! You need to log in before you can access this resource. Log in and you'll be good to go.`,
  },
  403: {
    title: `403 Forbidden`,
    message: `Sorry, but you don't have permission to access this page. If you think there's been a mistake, ask someone for help.`,
  },
  404: {
    title: `404 Not Found`,
    message: `Oops! We couldn't find the page you're looking for. Try double-checking the address (URL) and see if that helps.`,
  },
  500: {
    title: `500 Internal Server Error`,
    message: `Yikes! There was a problem on our end. Don't worry, we'll fix it as soon as we can.`,
  },
  502: {
    title: `502 Bad Gateway`,
    message: `Hmm, it looks like there was a problem connecting to the server. Don't worry, just give it a few minutes and try again.`,
  },
  503: {
    title: `503 Service Unavailable`,
    message: `Whoops! The server is busy right now. Try again in a little bit and you should be able to access the page.`,
  },
  unknown: {
    title: `Uh oh, something went wrong!`,
    message: `Don't worry, just try refreshing the page or asking someone for help. We'll fix it as soon as we can.`,
  },
};
